<template>
	<v-btn class="fancy-btn" text @click="$emit(`click`)" :disabled="disabled">
		<span class="fancy-btn--icon">
			<v-icon large>{{icon}}</v-icon>
		</span>
		<span class="fancy-btn--text">{{text}}</span>
	</v-btn>
</template>

<script>
export default {
	name: 'FancyButton',
	props: {
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean,
			required: false
		}
	}
}
</script>

<style lang="scss" scoped>
.fancy-btn {
	width: 100px;
	height: 80px !important;
	overflow: hidden;

	::v-deep .v-btn__content {
		display: block !important;
		width: 100px;
	}

	::v-deep .v-btn__content span {
		margin: 5px 0 !important;
		display: block !important;
	}

	::v-deep .fancy-btn--text {
		font-size: 11px;
		white-space: break-spaces;
		padding: 0px;
	}
}
</style>